module.exports = __webpack_public_path__ + "img/ic_addorder.429a1840.svg";